import { Flex, Text, type FlexProps, type SelectProps } from '@mantine/core';
import classes from './FormManagerSelect.module.scss';
import { ManagerSelect } from '../ManagerSelect';

interface FormManagerSelect extends SelectProps {
  title?: string;
  description?: string;
  containerProps?: FlexProps;
}

export const FormManagerSelect = ({
  title = 'Менеджер компании',
  description = 'Контактное лицо компании, администрирует компанию',
  containerProps,
  ...props
}: FormManagerSelect) => {
  return (
    <Flex gap='24' className={classes.formRow} {...containerProps}>
      <Flex direction='column' gap={6} className={classes.leftColumn}>
        <Text className={classes.title}>{title}</Text>
        <Text className={classes.description}>{description}</Text>
      </Flex>

      <ManagerSelect
        {...props}
        className={classes.rightColumn}
        variant='filled'
      />
    </Flex>
  );
};
